// Mobile nav toggle
function toggleMobileNav() {
  var nav = document.getElementById('mobileNav');
  var overlay = document.getElementById('mobileNavOverlay');
  if (!nav || !overlay) return;
  var isOpen = nav.classList.contains('open');
  nav.style.display = 'block';
  overlay.style.display = 'block';
  if (isOpen) {
    nav.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function() {
      if (!nav.classList.contains('open')) {
        nav.style.display = 'none';
        overlay.style.display = 'none';
      }
    }, 300);
  } else {
    nav.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
}

// Close mobile nav on ESC
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var nav = document.getElementById('mobileNav');
    if (nav && nav.classList.contains('open')) toggleMobileNav();
  }
});

// Sticky header — toggle class instead of inline styles
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        if (window.scrollY > 60) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  });
})();

// Intersection observer for subtle scroll-in animations
(function() {
  if (!window.IntersectionObserver) return;
  var els = document.querySelectorAll('.trust-item, .product-card, .testimonial-card, .philosophy-inner');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.5s ease ' + (i * 0.06) + 's, transform 0.5s ease ' + (i * 0.06) + 's';
    observer.observe(el);
  });
})();
